import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CsrfTokenService {
  private maskedToken$ = new BehaviorSubject<string | null>(null);

  get(): string | null {
    return this.maskedToken$.value;
  }

  set(token: string | null): void {
    this.maskedToken$.next(token);
  }

  clear(): void {
    this.maskedToken$.next(null);
  }

  hasToken(): boolean {
    return typeof this.maskedToken$.value === 'string' && this.maskedToken$.value.length > 0;
  }

  waitForTokenOnce(): Observable<string> {
    return this.maskedToken$.pipe(
      filter((t: string | null): t is string => typeof t === 'string' && t.length > 0),
      take(1),
    );
  }
}
